/**
 * Global CMBuildTopNav component.
 */

// import primary libararies
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import classNames from 'classnames';

// import components
import Base from '../../../global/components/BaseComponent.js.jsx';
import CloseWrapper from '../../../global/components/helpers/CloseWrapper.js.jsx';
import ProfileDropdownNav from '../../../global/components/navigation/ProfileDropdownNav.js.jsx';

// import admin styles
import contentModuleStyles from '../contentModuleModuleStyles.css';

class CMBuildTopNav extends Base {
  constructor(props, context) {
    super(props);
    this.state = {
      profileOpen: false
      , sideOpen: false
    }
    this._bind(
      '_openProfile'
      , '_openSide'
      , '_closeMenus'
    );
  }

  _openSide() {
    this.setState({
      sideOpen: true
    });
  }

  _openProfile() {
    this.setState({
      profileOpen: true
    });
  }

  _closeMenus() {
    this.setState({
      profileOpen: false
      , sideOpen: false
    });
  }

  render() {
    let { loggedInUser, contentModuleStore } = this.props;
    let { profileOpen, sideOpen } = this.state;

    let pictureUrl = '/img/defaults/profile.png';
    if(loggedInUser && loggedInUser.profilePicUrl) {
      pictureUrl = loggedInUser.profilePicUrl;
    }
    // console.log(pictureUrl);

    let profileImg = {backgroundImage: `url(${pictureUrl})`};

    const contentModule = contentModuleStore.selected.getItem();
    return(
      <header className="header build-top-nav">
        <div className="topbar">
          <CloseWrapper
            isOpen={(this.state.sideOpen || this.state.profileOpen)}
            closeAction={this._closeMenus}
          />
          <div className="actions">
            <div className="yt-row center-vert">
              <div className="yt-col _10">
                <Link className="-back-link" to={`/admin/authoring/content-modules/${contentModule ? contentModule._id : ''}`} ><i className="fas fa-arrow-left"/> Back</Link>
              </div>
              <div className="yt-col _80">
                <div className="-tm-title">
                  <strong>CM: </strong>
                  {contentModule ? contentModule.title : null}
                </div>
              </div>
              <ul className="navigation">
                { loggedInUser.username ?
                    <li className="dropdown">
                      <span className="action-link" onClick={this._openProfile}>
                        <div className="-profile-pic" style={profileImg} />
                      </span>
                      <ProfileDropdownNav
                        close={this._closeMenus}
                        isOpen={this.state.profileOpen}
                      />
                    </li>
                  :
                    null
                }
              </ul>
            </div>
          </div>
        </div>
      </header>
    )
  }

}

CMBuildTopNav.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CMBuildTopNav)
);



// WEBPACK FOOTER //
// modules/contentModule/components/CMBuildTopNav.js.jsx